import { InjectionToken, Service } from '@angular/core';

export const BAAS_DATE_TIME_PICKER_PROVIDER = new InjectionToken<BaasDateTimePickerProvider>('BarDateTimePicker provider');

export interface BaasDateTimePickerProvider {
    /** Handles shortcut keyboard events to set a given date. Return undefined to do nothing. */
    handleShortcut?(event: KeyboardEvent): Date | undefined | null;
}

@Service({ autoProvided: false })
export class _BaasDateTimePickerNoopProvider implements BaasDateTimePickerProvider {}
